import ProductionDuration from "@/roc/effects/Production/ProductionDuration";
import ProductionOutput from "@/roc/effects/Production/ProductionOutput";
import ProductionOutputType from "@/roc/effects/Production/ProductionOutputType";
import EraType from "@/roc/era/EraType";
import AbstractProduction from "@/roc/effects/Production/AbstractProduction";
import EffectMechanic from "@/roc/effects/EffectMechanic";
import { useApplicationStore } from "@/roc/stores/ApplicationStore";
import { getGoodsList } from "@/roc/building/workshop/WorkshopOutput";
const WorkshopProductionDefinition = {
    stoneAge: { amount: 0, duration: 0 },
    bronzeAge: { duration: 10 * 60, amount: 10 },
    minoanEra: { duration: 30 * 60, amount: 30 },
    classicGreece: { duration: 60 * 60, amount: 60 },
    earlyRome: { duration: 90 * 60, amount: 90 },
    romanEmpire: { duration: 120 * 60, amount: 120 },
    byzantineEra: { duration: 120 * 60, amount: 120 },
    ageOfTheFranks: { duration: 120 * 60, amount: 120 },
    earlyGothicEra: { duration: 120 * 60, amount: 120 },
    feudalAge: { duration: 120 * 60, amount: 120 },
    highMiddleAges: { duration: 120 * 60, amount: 120 },
    iberianEra: { duration: 120 * 60, amount: 120 },
    kingdomOfSicily: { duration: 120 * 60, amount: 80 },
    lateGothicEra: { duration: 120 * 60, amount: 80 },
};
class WorkshopProduction extends AbstractProduction {
    __group;
    __effectEra;
    constructor(group, effectEra) {
        super(EffectMechanic.WORKSHOP_PRODUCTION, ProductionDuration.asDaily(), ProductionOutput.asDaily().withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS));
        this.__group = group;
        this.__effectEra = effectEra;
    }
    clone() {
        return new WorkshopProduction(this.__group, this.__effectEra);
    }
    formatDescription(level, era) {
        const appStore = useApplicationStore();
        const buildingEra = appStore.selectedEra || EraType.bronzeAge;
        const goodsMap = getGoodsList(this.__group);
        const goods = [];
        let index = 9999;
        for (const i in goodsMap) {
            goods.push(goodsMap[i]);
            if (i === this.__effectEra) {
                index = goods.length - 1;
            }
            if (i === buildingEra) {
                break;
            }
        }
        if (goods.length - 1 < index) {
            return null;
        }
        let amount = WorkshopProductionDefinition[buildingEra].amount;
        amount = this.applyMods(amount);
        const result = [
            'Produce',
            amount,
            goods[index].split('_').join(' '),
            'over'
        ];
        const totalMinutes = Math.floor(WorkshopProductionDefinition[buildingEra].duration / 60);
        const hours = Math.round(Math.floor(totalMinutes / 60));
        const minutes = totalMinutes - hours * 60;
        if (hours > 0) {
            result.push(hours + 'h');
        }
        if (minutes > 0) {
            result.push(minutes + 'm');
        }
        return result.join(' ');
    }
}
export default WorkshopProduction;
